module.exports = __webpack_public_path__ + "img/mental-health.adef90dc.svg";